import { z } from 'zod/v4';

// Enum для методов аутентификации токена
export const TokenEndpointAuthMethod = z.enum([
  'client_secret_basic',
  'client_secret_post',
  'client_secret_jwt',
  'private_key_jwt',
  'none',
]);
export type TokenEndpointAuthMethod = z.infer<typeof TokenEndpointAuthMethod>;

export const OIDCAttributeSyncType = z.enum([
  'DISABLE',
  'PERIODIC',
  'ON_CREATE',
  'IF_EXIST',
]);
export type OIDCAttributeSyncType = z.infer<typeof OIDCAttributeSyncType>;

export const OIDCAttributeExpressionSchemaDTO = z.object({
  name: z.string(),
  expression: z.string(),
  sync_type: z.enum(['DISABLE', 'PERIODIC', 'ON_CREATE', 'IF_EXIST']),
});
export type OIDCAttributeExpression = z.infer<
  typeof OIDCAttributeExpressionSchemaDTO
>;

// Базовая схема OIDC провайдера (все обязательные поля без client_secret)
const OIDCProviderDTO = z.object({
  name: z.string(),
  display_name: z.string(),
  client_id: z.string(),
  authorize_url: z.string().nullable(),
  access_token_url: z.string().nullable(),
  userinfo_endpoint: z.string().nullable(),
  server_metadata_url: z.string().nullable(),
  token_endpoint_auth_method: TokenEndpointAuthMethod.nullable(),
  verify_ssl: z.boolean(),
  scope: z.string(),
  attribute_expressions: z.array(OIDCAttributeExpressionSchemaDTO),
  active: z.boolean(),
  login_expression: z.string(),
});

// OIDC провайдер (ответ от API, без client_secret)
export type OIDCProvider = z.infer<typeof OIDCProviderDTO>;

// OIDC провайдер для списка (то же самое, что и OIDCProvider)
export type OIDCProviderListItem = OIDCProvider;

// Схема для создания OIDC провайдера (с обязательным client_secret)
const OIDCProviderCreateSchema = OIDCProviderDTO.extend({
  client_secret: z.string(),
  verify_ssl: z.boolean().optional(),
  scope: z.string().optional(),
  attribute_expressions: z.array(OIDCAttributeExpressionSchemaDTO).optional(),
  active: z.boolean().optional(),
  login_expression: z.string(),
});
export type OIDCProviderCreate = z.infer<typeof OIDCProviderCreateSchema>;

const OIDCProviderUpdateSchema = z.object({
  display_name: z.string().optional(),
  client_id: z.string().optional(),
  client_secret: z.string().optional(),
  authorize_url: z.string().nullable().optional(),
  access_token_url: z.string().nullable().optional(),
  userinfo_endpoint: z.string().nullable().optional(),
  server_metadata_url: z.string().nullable().optional(),
  token_endpoint_auth_method: TokenEndpointAuthMethod.nullable().optional(),
  verify_ssl: z.boolean().optional(),
  scope: z.string().optional(),
  attribute_expressions: z.array(OIDCAttributeExpressionSchemaDTO).optional(),
  active: z.boolean().optional(),
  login_expression: z.string().optional(),
});
export type OIDCProviderUpdate = z.infer<typeof OIDCProviderUpdateSchema>;